import { Cloneable } from '../Cloneable.js';
import { TCModelError } from '../errors/index.js';
/**
 *
 */
export class Vector extends Cloneable {
    /**
 *
 *
 */
    bitLength = 0;
    maxId_ = 0;
    set_ = new Set();
    *[Symbol.iterator]() {
        for (let i = 1; i <= this.maxId; i++) {
            yield [i, this.has(i)];
        }
    }
    /**
 *
 *
 *
 *
 */
    values() {
        return this.set_.values();
    }
    /**
 *
 *
 *
 */
    get maxId() {
        return this.maxId_;
    }
    /**
 *
 *
 *
 *
 */
    has(id) {
        /**
 *
 */
        return this.set_.has(id);
    }
    /**
 *
 *
 *
 *
 */
    unset(id) {
        if (Array.isArray(id)) {
            id.forEach((id) => this.unset(id));
        }
        else if (typeof id === 'object') {
            this.unset(Object.keys(id).map((strId) => Number(strId)));
        }
        else {
            this.set_.delete(Number(id));
            /**
 *
 */
            this.bitLength = 0;
            if (id === this.maxId) {
                /**
 *
 *
 */
                this.maxId_ = 0;
                this.set_.forEach((id) => {
                    this.maxId_ = Math.max(this.maxId, id);
                });
            }
        }
    }
    isIntMap(item) {
        let result = (typeof item === 'object');
        result = (result && Object.keys(item).every((key) => {
            let itemResult = Number.isInteger(parseInt(key, 10));
            itemResult = (itemResult && this.isValidNumber(item[key].id));
            itemResult = (itemResult && item[key].name !== undefined);
            return itemResult;
        }));
        return result;
    }
    isValidNumber(item) {
        return (parseInt(item, 10) > 0);
    }
    isSet(item) {
        let result = false;
        if (item instanceof Set) {
            result = Array.from(item).every(this.isValidNumber);
        }
        return result;
    }
    /**
 *
 *
 *
 *
 *
 *
 */
    set(item) {
        /**
 *
 *
 */
        if (Array.isArray(item)) {
            item.forEach((item) => this.set(item));
        }
        else if (this.isSet(item)) {
            this.set(Array.from(item));
        }
        else if (this.isIntMap(item)) {
            this.set(Object.keys(item).map((strId) => Number(strId)));
        }
        else if (this.isValidNumber(item)) {
            this.set_.add(item);
            this.maxId_ = Math.max(this.maxId, item);
            /**
 *
 */
            this.bitLength = 0;
        }
        else {
            /**
 *
 */
            throw new TCModelError('set()', item, 'must be positive integer array, positive integer, Set<number>, or IntMap');
        }
    }
    empty() {
        this.set_ = new Set();
        this.maxId_ = 0;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    forEach(callback) {
        for (let i = 1; i <= this.maxId; i++) {
            callback(this.has(i), i);
        }
    }
    get size() {
        return this.set_.size;
    }
    setAll(intMap) {
        this.set(intMap);
    }
}
